<template>
  <div style="z-index: 24000; border: 0; position: fixed; bottom: 0; right: 0">
    <div
      :style="{ height: iframeNewHeight, width: iframeNewWidth }"
      ref="chatWidgetIframeContainer"
    >
      <render-to-i-frame
        id="mnv-chat-widget-frame"
        style="border: 0; width: 100%; height: 100%"
        ref="chatwidgetiframe"
        @iframeLoaded="setShowIframe"
        v-cloak
      >
        <chat-widget-prompt
          v-if="isPromptOpened"
          @promptClose="closePrompt"
          @promptClicked="showChatForm"
        ></chat-widget-prompt>
        <chat-widget-form
          @messagesent=""
          v-if="isChatOpened"
        ></chat-widget-form>
        <chat-widget-bubble
          @mouseover="mouseOverFn"
          @mouseleave="mouseLeaveFn"
          :isOpenedFromPrompt="isChatOpenedFromPrompt"
          @chatClicked="showChatForm"
        ></chat-widget-bubble>
      </render-to-i-frame>
      <!-- <chat-widget-iframe></chat-widget-iframe> -->
      <!--- Testing Purpose-->
    </div>
  </div>
</template>
<script>
import RenderToIFrame from "./RenderToIFrame";
import ChatWidgetBubble from "./ChatWidgetBubble.vue";
import axios from "axios";
import "./ChatWidget.css";
import ChatWidgetForm from "./ChatWidgetForm.vue";
import ChatWidgetPrompt from "./ChatWidgetPrompt.vue";
import { ref } from "vue";
import ChatWidgetIFrameUpd from "./ChatWidgetIFrameUpd";
export default {
  components: {
    ChatWidgetBubble,
    RenderToIFrame,
    ChatWidgetForm,
    ChatWidgetPrompt,
  },
  name: "ChatWidget",
  data() {
    return {
      isMessageSent: false,
      sentMessage: "",
      isChatOpened: false,
      iframeNewHeight: "100px",
      iframeNewWidth: "100px",
      isPromptOpened: false,
      showIframe: false,
      // isChatOpenedFromPrompt: false
    };
  },
  methods: {
    mouseOverFn() {
      if (!this.isChatOpened) {
        this.iframeNewHeight = "225px";
        this.iframeNewWidth = "370px";
        this.isPromptOpened = true;
      }
    },
    mouseLeaveFn() {
      if (!this.isChatOpened) {
        this.iframeNewHeight = "";
        this.iframeNewWidth = "";
        this.isPromptOpened = false;
        this.adjustIframeDimensions();
      }
    },
    showChatBox() {
      const mnvIframe = document.getElementById("mnv-chat-bubble");
      if (mnvIframe) {
        mnvIframe.style.width = "300px";
        mnvIframe.style.height = "300px";
      }
    },
    showChatForm() {
      this.isChatOpened = !this.isChatOpened;
      this.isChatOpenedFromPrompt = true;
      this.isPromptOpened = false;
      this.$nextTick().then(() => {
        this.adjustIframeDimensions();
      });
    },
    adjustIframeDimensions() {
      let iframeNewHeight;
      let iframeNewWidth;
      // const iframeElement = document.getElementById("mnv-chat-iframe");
      // const iframeDivElement = document.getElementById(
      //   "chatWidgetIframeContainer"
      // );

      if (this.isChatOpened) {
        iframeNewHeight =
          this.$refs.chatwidgetiframe.$el.contentWindow.document.body
            .scrollHeight;
        iframeNewWidth =
          this.$refs.chatwidgetiframe.$el.contentWindow.document.body
            .scrollWidth;
      } else {
        iframeNewHeight = 50;
        iframeNewWidth = 50;
      }
      this.iframeNewHeight = `${iframeNewHeight + 50}px`;
      this.iframeNewWidth = `${iframeNewWidth + 50}px`;
    },
    closePrompt() {
      this.isPromptOpened = false;
      this.$nextTick().then(() => {
        this.iframeNewHeight = "100px";
        this.iframeNewWidth = "100px";
      });
    },
    setShowIframe() {
      this.showIframe = true;
    },
  },
  mounted() {
    setTimeout(() => {
      // this.isPromptOpened = true;
      this.$nextTick().then(() => {
        this.iframeNewHeight = "";
        this.iframeNewWidth = "";
        this.adjustIframeDimensions();
      });
    }, 500);
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
